<div class="remove-note-dialog-container">
    <div class="remove-note-dialog-header-container">
        <div>  <p class="remove-note-dialog-header-text remove-note-item-section-headers">Remove Note</p></div>
        <div><p class="remove-note-dialog-sub-heading">Are you sure you want to remove this note?</p></div>
    </div>

    <div class="order-note-btn-dialog-container">

        <button class="cancel-note-dialog-btn" mat-flat-button type="button" (click)="cancelRemovingNote()">
            <div class="cancel-alt-btn-content">
                <span><p class="cancel-alt-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="remove-order-note-btn" mat-flat-button type="button"
                (click)="deleteNewOrderNote()">
            <div class="remove-order-note-btn-content">
                <span><p class="remove-order-note-btn-text">REMOVE NOTE</p></span>
            </div>
        </button>
    </div>

</div>
